import React from "react";
import { Link } from "react-router-dom";
import { motion } from "motion/react";
import { Clock, Eye, Hash, User } from "lucide-react";

export default function ArticleCard({ article }) {
  const authorName = article.author?.name || "Эксперт";
  const authorAvatar = article.author?.avatar_url || "";
  const authorTitle = article.author?.title || "";

  const publishedDate = article.published_at
    ? new Date(article.published_at).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "long",
        year: "numeric"
      })
    : "";

  return (
    <Link to={`/articles/${article.slug}`} className="block group">
      <motion.article
        id={`article-card_${article.id}`}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="p-6 rounded-md bg-neutral-900/50 border border-neutral-800/40 hover:border-primary-700/30 transition-colors"
      >
        <div className="flex flex-wrap gap-2 mb-3">
          {(article.tags || []).slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md bg-primary-500/10 text-primary-400 text-lg font-extralight"
            >
              <Hash className="w-3 h-3" />
              {tag}
            </span>
          ))}
        </div>

        <h2 className="text-xl font-medium text-neutral-100 mb-2 group-hover:text-primary-400 transition-colors line-clamp-2">
          {article.title}
        </h2>

        <p className="text-lg font-extralight text-neutral-400 mb-4 line-clamp-3">
          {article.excerpt}
        </p>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {authorAvatar ? (
              <img
                src={authorAvatar}
                alt={authorName}
                className="w-8 h-8 rounded-full object-cover"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
                <span className="text-white text-lg font-medium">{authorName[0]}</span>
              </div>
            )}
            <div>
              <p className="text-lg font-extralight text-neutral-200">{authorName}</p>
              {authorTitle && (
                <p className="text-lg font-extralight text-neutral-500">{authorTitle}</p>
              )}
            </div>
          </div>

          <div className="flex items-center gap-4 text-lg font-extralight text-neutral-500">
            <div className="flex items-center gap-1">
              <Clock className="w-4 h-4" />
              <span>{article.reading_time} мин</span>
            </div>
            <div className="flex items-center gap-1">
              <Eye className="w-4 h-4" />
              <span>{article.views_count || 0}</span>
            </div>
            <span>{publishedDate}</span>
          </div>
        </div>
      </motion.article>
    </Link>
  );
}
